import { getChannel, getDocument, getPlaceId, imageMetaConverter } from '@lib/server';
import { IconGlassOff } from '@tabler/icons-react';
import { Aggregator, Menu, Place } from '@types';

import { Card } from '../components/card';
import { MenuCard } from '../components/menu-card';
import { BlockBase } from './utils';

export async function MenuGrid({ params, id }: BlockBase) {
  const channel = await getChannel(decodeURIComponent(params.domain));
  if (!channel) return null;

  const menus: Menu[] = [];

  if (!params?.venue) {
    const { fields } = await getDocument<Aggregator>('aggregator', channel.micrositeData?.[0]?.id, {
      tags: [channel.channelId],
      depth: 1,
      select: ['fields.brandMenus', 'fields.name'],
    });
    if (fields?.brandMenus) {
      menus.push(...fields.brandMenus.filter(Boolean));
    }
  } else {
    const { placeId } = await getPlaceId(channel, decodeURIComponent(params.venue));

    if (!placeId) return null;

    const { fields } = await getDocument<Place>('place', placeId, {
      tags: [channel.channelId],
      depth: 1,
      select: ['fields.custom.venueMenus', 'fields.name'],
    });
    if (fields?.custom?.venueMenus) {
      menus.push(...fields.custom.venueMenus.filter(Boolean));
    }
  }

  return (
    <>
      {menus?.length === 0 && (
        <Card
          icon={{
            svg: <IconGlassOff stroke={1.5} size={64} />,
          }}
          contentAlignment={{
            alignment: { horizontalAlignment: 'center' },
          }}
          layout="dialog"
          title="No menus available."
          description="Please try again later."
        />
      )}

      {menus?.length > 0 && (
        <section
          id={id}
          className="flex w-full max-w-(--breakpoint-2xl) flex-wrap justify-center gap-4 px-4 sm:px-8 md:gap-8"
        >
          {menus?.map((menu) => (
            <MenuCard
              key={menu.name}
              description={menu.description?.content}
              featuredImage={menu.featuredImage}
              title={menu.title}
              menuPdf={imageMetaConverter(menu.menuPdf)?.src || ''}
            />
          ))}
        </section>
      )}
    </>
  );
}
